import { HsGraphicSprite } from '../../graphic-render-new/objects/graphic-sprite.class';
import type { HsParticle } from './particle.interface';
import { HsVector3 } from '../../math-new/objects/vector3.class';

export class HsParticleSprite extends HsGraphicSprite implements HsParticle {
  public size: number = 1;
  public age: number = 0;
  public position: HsVector3 = HsVector3.makeZeroVector();
  public velocity: HsVector3 = HsVector3.makeZeroVector();
  public acceleration: HsVector3 = HsVector3.makeZeroVector();

  public update(): void {
    this.velocity.add(this.acceleration);
    this.position.add(this.velocity);
    this.worldMatrix.setPosition(this.position.values);
  }
}
